module.exports = __webpack_public_path__ + "img/52-image-1-1@2x.fb6941f2.png";